export default "__VITE_ASSET__bdb28f9c__"